import type { AssetLite } from "@/entities/asset";

import { uniq } from "@/utilities/array";

export const getAssetsInitialReplacementCost = (assets: AssetLite[]) => {
  const initialValue = uniq(assets.map((a) => a.replacement_cost));
  return initialValue.length === 1 ? initialValue[0] : undefined;
};
